<section class="information-wrapper">
<!--  else loading-->
  <ng-container *ngIf="(data$ | async) as filteredData;">
    <section *ngIf="filteredData.length || panelConfiguration.type === 'expandable-card'"
            class="section-wrapper" [ngSwitch]="panelConfiguration.type" [ngClass]="panelConfiguration.cssClass">

      <section class="section-content textual-section-content" *ngSwitchCase="'text'">
        <section *ngFor="let field of panelConfiguration.fields;trackBy:trackByFn('path', 'path')">
          <gen-textual-content *ngIf="filteredData.length"
            [ngClass]="field?.path|automationLocator:'TEXT'"
            [showTitle]="true"
            [checkBlank]="true"
            [item]="filteredData[0]"
            [fieldConfig]="field"
          >
          </gen-textual-content>
        </section>
      </section>

      <ng-container *ngSwitchCase="'list'">
        <ng-container *ngIf="filteredData.length">
          <header class="section-titles">
            <span *ngFor="let field of panelConfiguration.fields;trackBy:trackByFn('path', 'path')"
                class="single-title {{field?.cssClasses}}"
                [ngClass]="field?.path|automationLocator:'LABEL'"
            >{{field.label}}</span>
            <span class="single-title action-title info" *ngIf="panelConfiguration.infoFormId">Info</span>
            <span *ngIf="panelConfiguration.selectAvailable" class="single-title action-title toggle-switch-column">Select</span>
          </header>
          <section class="section-content list-section-content">
            <gen-treatment-option
              *ngFor="let item of filteredData; trackBy:trackByFn(panelConfiguration.fields[0].path, 'id')"
                    class="single-option"
                    [data]="item"
                    [isSelectable]="panelConfiguration.selectAvailable"
                    [fields]="panelConfiguration.fields"
                    [indexProperty]="indexProperty"
                    [infoFormId]="panelConfiguration.infoFormId"
                    (onSelect)="addToSelection($event)"
                    (onDeselect)="removeFromSelection($event)"
            ></gen-treatment-option>
          </section>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="'expandable-card'">
        <gen-expandable-information-card-wrapper
          class="section-content single-card-option"
          [data]="filteredData"
          [panelConfiguration]="panelConfiguration"
        ></gen-expandable-information-card-wrapper>
      </ng-container>

      <ng-container *ngSwitchCase="'card'">
        <gen-information-card
            *ngFor="let row of filteredData; trackBy:trackByFn(panelConfiguration.fields[0].path,'id')"
            class="single-card-option"
            [selectByDefault]="panelConfiguration.additionalData?.selectByDefault"
            [data]="row"
            [identifier]="row?.id"
            [formId]="formId"
            [expended]="false"
            [hideMoreInfo]="panelConfiguration.additionalData?.hideMoreInfo"
            [selectable]="panelConfiguration.selectAvailable"
            [titles]="panelConfiguration.titles"
            [shortFormConfig]="shortFormItems"
            [formConfig]="formItems"
            [cardLayerConfig]="panelConfiguration.additionalData?.cardLayerConfig"
            (onSelect)="addToSelection($event)"
            (onDeselect)="removeFromSelection($event)"
        ></gen-information-card>
      </ng-container>

      <ng-container *ngSwitchCase="'form'">
        <gen-dynamic-form
          class="treatments-form"
          [formName]="panelConfiguration?.formId"
          [formConfig]="formItems"
          [formData]="panelConfiguration?.additionalData?.dataStructure === 'list' ? filteredData : additionalData"
          [editMode]="false"
          [formVertical]="true"
          [additionalSearchValues]="additionalSearchValues$ | async"
          [disabled]="!panelConfiguration.selectAvailable"
          (formChange)="onFormChange($event.form)"
        ></gen-dynamic-form>
      </ng-container>
    </section>

    <section [ngClass]="customEmptyMessage ? 'no-items-message' : 'sub-title'"
             *ngIf="!filteredData.length && panelConfiguration.type !== 'expandable-card'"
    >
      <span> {{customEmptyMessage ? (customEmptyMessage | stringTranslate) : (staticEmptyMessage | stringTranslate)}} </span>
    </section>
  </ng-container>
</section>

<ng-template #loading>
  <gen-overlay-loader class="loader-wrapper" [showOverlay]="true"></gen-overlay-loader>
</ng-template>

